import { useEffect, useState } from "react";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import { StatusBar } from "../../components/common";
import SupplierTable from "../../components/supplier/SupplierTable";
import useApi from "../../api";
import SupplierForm from "../../components/supplier/SupplierForm";
import { handleRetriveError } from "../../utils";

function Supplier() {
  const [isOpenSupplierCreateForm, setIsOpenSupplierCreateForm] = useState<boolean>(false);
  const api = useApi()
  const [suppliers, setSuppliers] = useState<any>()

  const getSuppliers = () => {
    api.getSuppliers().then((response:any)=>{
      setSuppliers(response)
    }, handleRetriveError)
  };

  useEffect(()=>{
    getSuppliers()
  },[])

  return (
    <PageBodyWrapper>
      <StatusBar
        statusList={[]}
        buttonLabel="Add Supplier"
        onButtonClick={() =>
          setIsOpenSupplierCreateForm(!isOpenSupplierCreateForm)
        }
      />
      <SupplierTable data={suppliers} refresh={getSuppliers}/>
      <SupplierForm isOpen={isOpenSupplierCreateForm} onClose={()=>setIsOpenSupplierCreateForm(!isOpenSupplierCreateForm)} refresh={getSuppliers}/>
    </PageBodyWrapper>
  );
}

export default Supplier;
